(function () {
    'use strict';
    angular.module('app').controller('PromoCodeController', PromoCodeController);
    PromoCodeController.$Inject = [
        'data',
        '$scope',
        'AffiliateService',
        '$uibModalInstance',
        'toastr',
        '$rootScope',
        'ClientService',
        '$filter'
    ]

    function PromoCodeController(data, $scope, AffiliateService, $uibModalInstance, toastr, $rootScope, ClientService, $filter) {
        const vm = this;
        vm.data = angular.copy(data);
        vm.modalClose = closeModal;
        vm.promoCode = {};

        vm.subAffiliates = [{
            owner: '',
            commission: ''
        }];

        vm.toggleFromDatepicker = toggleFromDatepicker;
        vm.toggleToDatepicker = toggleToDatepicker;
        vm.setToDatepickerOptions = setToDatepickerOptions;
        vm.setFromDatepickerOptions = setFromDatepickerOptions;
        vm.addSubAffiliate = addSubAffiliate;
        vm.removeSubAffiliate = removeSubAffiliate;
        vm.change = changed;
        vm.searchForCompanies = getCompany;

        vm.fromDatepickerOptions = {
            maxDate: null
        };

        vm.toDatepickerOptions = {
            maxDate: null
        };

        vm.discountTypeList = [
            { viewName: 'Discount Value', type: '1' },
            { viewName: 'Discount Percent', type: '2' },
            { viewName: 'No Discount', type: '' }
        ]

        vm.commissionTypeList = [
            { viewName: 'Commission Value', type: '1' },
            { viewName: 'Commission Percent', type: '2' },
            { viewName: 'No Commission', type: '' }
        ]

        vm.submit = function (form) {
            if (form.$invalid) {
                for (let field of $scope.form.$error.required) {
                    if (field.$name) {
                        $scope.form[field.$name].$touched = true
                    }
                }
                toastr.error('Promo code details is empty!');
                return;
            }
            if (vm.checkSelect) {
                vm.promoCode.code = null
            }

            save();
        };

        init();

        function changed() {
            hideSelectedData();
        }

        function init() {
            vm.id = data;
            getCompany();
            getReferrer();

        }

        function addSubAffiliate() {
            vm.subAffiliates.push({ owner: '', commission: '' });
        }

        function removeSubAffiliate(index) {
            vm.subAffiliates.splice(index, 1)
        }

        function getReferrer(data) {
            AffiliateService.getUserMarketing(
                res => {
                    res.content.forEach(item => {
                        item.fullname = `${item.firstName} ${item.lastName}`
                    });
                    vm.companies = res.content;
                },
                err => {
                    toastr.error(err.message);
                },
                {
                    size: 500,
                    companyMarketingId: vm.id
                }
            );
        }

        function getCompany(search) {

            ClientService.Company.getAll(
                res => {
                    vm.companyList = res.content
                },
                err => {
                    console.log(err)
                }, { name: search ? search.search : '', size: 1000 });
        }

        function hideSelectedData() {
            const affiliates = [];
            vm.subAffiliates.forEach(res => {
                vm.companies = vm.companies.filter(item => item.id !== res.owner.id);

            })


        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }

        function save() {
            vm.loading = true;
            const payload = cleanPayload();
            AffiliateService.createPromoCode(
                res => {
                    vm.loading = false
                    toastr.success('Successfully Created!');
                    $uibModalInstance.close();

                },
                err => {
                    vm.loading = false
                    toastr.error(err.message, err.code)
                }, payload)
        }

        function cleanPayload() {
            const payload = {
                companyMarketingId: vm.id,
                active: vm.promoCode.active,
                code: vm.promoCode.code,
                discountType: vm.discountType ? 'margin' : 'sales',
                description: vm.promoCode.description,
                discountPercent: vm.promoCode.discountPercent,
                discountValue: vm.promoCode.discountValue,
                durationDay: vm.promoCode.durationDay,
                durationMonth: vm.promoCode.durationMonth,
                durationWeek: vm.promoCode.durationWeek,
                maximumDiscount: vm.promoCode.maximumDiscount,
                endDate: $filter('date')(vm.promoCode.endDate, 'yyyy-MM-dd'),
                noBooking: vm.promoCode.noBooking,
                startDate: $filter('date')(vm.promoCode.startDate, 'yyyy-MM-dd'),
                userMarketingList: userMarketingIds(),
                referredCompanyIds: referredCompanyIds()
            };

            return payload;
        }

        function referredCompanyIds() {
            const referredCompanyIds = [];
            if (!vm.promoCode.referredCompanyIds) return [];
            vm.promoCode.referredCompanyIds.forEach(company => {
                referredCompanyIds.push(company.id)
            });

            return referredCompanyIds;
        }

        function userMarketingIds() {
            const payload = [];
            vm.subAffiliates.forEach(affiliate => {
                payload.push({
                    userMarketingId: affiliate.owner.id,
                    commissionValue: affiliate.commissionValue,
                    commissionPercent: affiliate.commissionPercent
                })
            });

            return payload
        }

        function setFromDatepickerOptions() {
            vm.toDatepickerOptions = {
                minDate: vm.promoCode.startDate ? new Date(vm.promoCode.startDate) : null
            }
        }

        function setToDatepickerOptions() {
            vm.fromDatepickerOptions = {
                maxDate: vm.promoCode.endDate ? new Date(vm.promoCode.endDate) : null
            }
        }

        function toggleFromDatepicker() {
            vm.isFromDatepickerOpen = !vm.isFromDatepickerOpen;
        }

        function toggleToDatepicker() {
            vm.isToDatepickerOpen = !vm.isToDatepickerOpen;
        }

    }
})()



// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/modal/promoCodeController.js